/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ObservationDto } from './ObservationDto';
import {
    ObservationDtoFromJSON,
    ObservationDtoFromJSONTyped,
    ObservationDtoToJSON,
    ObservationDtoToJSONTyped,
} from './ObservationDto';

/**
 * 
 * @export
 * @interface InspectionCategoryTypeDto
 */
export interface InspectionCategoryTypeDto {
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeDto
     */
    categoryTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof InspectionCategoryTypeDto
     */
    externalId?: string;
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeDto
     */
    categoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof InspectionCategoryTypeDto
     */
    typeId?: number;
    /**
     * 
     * @type {Array<ObservationDto>}
     * @memberof InspectionCategoryTypeDto
     */
    observations?: Array<ObservationDto>;
}

/**
 * Check if a given object implements the InspectionCategoryTypeDto interface.
 */
export function instanceOfInspectionCategoryTypeDto(value: object): value is InspectionCategoryTypeDto {
    return true;
}

export function InspectionCategoryTypeDtoFromJSON(json: any): InspectionCategoryTypeDto {
    return InspectionCategoryTypeDtoFromJSONTyped(json, false);
}

export function InspectionCategoryTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InspectionCategoryTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryTypeId': json['categoryTypeId'] == null ? undefined : json['categoryTypeId'],
        'externalId': json['externalId'] == null ? undefined : json['externalId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'typeId': json['typeId'] == null ? undefined : json['typeId'],
        'observations': json['observations'] == null ? undefined : ((json['observations'] as Array<any>).map(ObservationDtoFromJSON)),
    };
}

export function InspectionCategoryTypeDtoToJSON(json: any): InspectionCategoryTypeDto {
    return InspectionCategoryTypeDtoToJSONTyped(json, false);
}

export function InspectionCategoryTypeDtoToJSONTyped(value?: InspectionCategoryTypeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryTypeId': value['categoryTypeId'],
        'externalId': value['externalId'],
        'categoryId': value['categoryId'],
        'typeId': value['typeId'],
        'observations': value['observations'] == null ? undefined : ((value['observations'] as Array<any>).map(ObservationDtoToJSON)),
    };
}

